module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_ciclo_cultivo_5.664bbd13.jpg";